import { produce } from 'immer'
import merge from 'lodash.merge'
// @ts-ignore
import { str } from './utils'
import accountActions from '../actions/account'
import authActions from '../actions/auth'
import { Account } from '../types/Account'

export interface AccountState {
  [id: string]: Account
}

const initialState: AccountState = {}

const reducer = (draft: AccountState, { type, payload }: any) => {
  switch (type) {
    case str(accountActions.read.success): {
      const data = payload.data
      if (data && data.uid) {
        draft[data.uid] = merge(draft[data.uid] || {}, data)
      }
      return
    }
    case str(authActions.logout.success):
      return initialState
  }
}

export default (state = initialState, action: any) =>
  produce(state, (draft: AccountState) => reducer(draft, action))
